import FollowUpTypography from './FollowUpTypography';

export default FollowUpTypography;
